import withBookingCurrency from 'components/queries/withBookingCurrencyQuery';
import PaymentPendingContainer from './PaymentPendingContainer';

export default withBookingCurrency(PaymentPendingContainer);
